import React, {Component} from 'react';
import {observer} from 'mobx-react';
import './styles.scss';
import BaseButton from "../../components/button/BaseButton";
import {FormattedMessage} from "react-intl";

@observer
class VideoDecline extends Component {

    render() {
        const {peerUser, onClose} = this.props;
        if (!peerUser) {
            return null;
        }
        return (
            <div className="remote remote-waiting">
                <div className={"video-decline"}>
                    <div className={"avatar-icon"}/>
                    <div><FormattedMessage id={'video.chat.student.declined'} values={{teacherName: peerUser.name}}/></div>
                    <div className={"video-decline-buttons"}>
                        <BaseButton className="video-decline-close" onClick={onClose}
                                    label={<FormattedMessage id={'video.chat.close'}/>}/>
                    </div>
                </div>
            </div>
        );

    }
}

export default VideoDecline;
